@if (apiErrors.current(); as problem) {
  <div class="modal-backdrop fade show" (click)="close()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="apiErrorModalLabel" aria-modal="true" style="overflow-x: hidden; overflow-y: auto;" (click)="close()">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h4 class="modal-title text-danger" id="apiErrorModalLabel">
            <i class="ti ti-x-circle me-1"></i>{{ 'common.apiError.modalTitle' | translate }}
          </h4>
          <button type="button" class="btn-close custom-btn-close" (click)="close()" [attr.aria-label]="'common.actions.close' | translate">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <h6 class="fw-semibold mb-1">{{ problem.title }}</h6>
            <p class="mb-0 text-muted">{{ problem.detail }}</p>
          </div>

          <h6 class="fw-semibold d-flex align-items-center gap-1 mb-2">
            <i class="ti ti-alert-triangle text-danger"></i>
            {{ 'common.apiError.errorsList' | translate: { count: problem.errors.length } }}
          </h6>
          <ul class="list-group list-group-flush mb-3">
            @for (message of problem.errors; track $index) {
              <li class="list-group-item small py-2 ps-3 border-start border-3 border-danger">{{ message }}</li>
            }
          </ul>

          @if (problem.traceId; as traceId) {
            <div class="border rounded p-2 bg-light d-flex align-items-center justify-content-between gap-2">
              <div class="small">
                <span class="fw-semibold">{{ 'common.apiError.traceId' | translate }}:</span>
                <code class="ms-1">{{ traceId }}</code>
                <div class="text-muted">{{ 'common.apiError.traceHint' | translate }}</div>
              </div>
              <button type="button" class="btn btn-white btn-sm d-inline-flex align-items-center" (click)="copyTraceId(traceId)">
                <i class="ti me-1" [class.ti-copy]="!copied()" [class.ti-check]="copied()"></i>
                {{ (copied() ? 'common.apiError.copied' : 'common.apiError.copy') | translate }}
              </button>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="close()">{{ 'common.actions.close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
}
